import type { Router, RouteRecordRaw } from 'vue-router';

import { beforeEnterGuard, ROUTES } from '../router';

export class RouterInitializerService {
  constructor(private readonly router: Router) {}

  initialize(route: RouteRecordRaw): void {
    route.name = ROUTES.LOGIN;

    this.router.addRoute({
      ...route,
      beforeEnter: beforeEnterGuard,
    });
  }
}
